import { DateTimeFilterMatchEnum } from "./autogenerated-deliveryService-gql/graphql";

export interface ITag {
  name: TagName;
  inputParameters: {
    plannedDeliveryDateFilter: Date | null;
    plannedDeliveryDateFilterMatch: DateTimeFilterMatchEnum | null;
  } | null;
}

export enum TagName {
  Today = "Today",
  Tomorrow = "Tomorrow",
  Future = "Future",
  NotPlanned = "NotPlanned",
  AllDeliveries = "AllDeliveries",
}
